export default __webpack_public_path__ + "static/media/Oval@1x.5cebf4d3.png";